import React, { useEffect, useState } from 'react'
import { MdEdit, MdDelete } from 'react-icons/md'
import SubCategoryModal from '../../Components/Modals/Our-Projects/Sub-Category'
import RecordPosition from '../../Components/Modals/RecordPosition/RecordPosition'
import { useProjects } from './useHook'
import { IoEye } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import GlobalPagination from '../../Components/Pagination/GlobalPagination'

const OurProjectCategories = () => {
    const navigate = useNavigate()
    const [currentOurProjectCategory, setCurrentOurProjectCategory] = useState(null)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isPositionModalOpen, setIsPositionModalOpen] = useState(false)
    const [selectedCategoryForPosition, setSelectedCategoryForPosition] = useState(null)
    const [ourProjectCategories, setOurProjectCategories] = useState([])
    const [pagination, setPagination] = useState({
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
        offset: 0,
        hasNextPage: false,
        hasPreviousPage: false
    })
    const [categoryName, setCategoryName] = useState("")
    const [parentCategory, setParentCategory] = useState("finishing")
    const { getSubCategories, updateSubCategoryPosition } = useProjects()

    const refreshData = async () => {
        const params = {
            offset: pagination.offset,
            limit: pagination.limit
        }
        if (categoryName) {
            params.category_name = categoryName
        }
        if (parentCategory) {
            params.parent_category = parentCategory
        }
        const paginationData = await getSubCategories(setOurProjectCategories, params)
        if (paginationData) {
            setPagination(paginationData)
        }
    }

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
        if (!isModalOpen) {
            setCurrentOurProjectCategory(null)
        }
    }

    const loadData = async () => {
        const params = {
            offset: pagination.offset,
            limit: pagination.limit
        }
        if (categoryName) {
            params.category_name = categoryName
        }
        if (parentCategory) {
            params.parent_category = parentCategory
        }
        const paginationData = await getSubCategories(setOurProjectCategories, params)
        if (paginationData) {
            setPagination(paginationData)
        }
    }

    useEffect(() => {
        loadData()
    }, [pagination.offset, pagination.limit])

    const handlePageChange = (newOffset) => {
        setPagination(prev => ({
            ...prev,
            offset: newOffset
        }))
    }

    const handleEditOurProjectCategory = (ourProjectCategory) => {
        setCurrentOurProjectCategory(ourProjectCategory)
        setIsModalOpen(true)
    }

    const handlePageView = (id) => {
        navigate(`/our-projects/${id}`)
    }

    const handlePositionClick = (category) => {
        setSelectedCategoryForPosition(category)
        setIsPositionModalOpen(true)
    }

    const handleUpdatePosition = async (id, position) => {
        await updateSubCategoryPosition(id, position)
        await refreshData()
    }

    const closePositionModal = () => {
        setIsPositionModalOpen(false)
        setSelectedCategoryForPosition(null)
    }

    const handleSearch = async () => {
        setPagination(prev => ({
            ...prev,
            offset: 0
        }))
        const params = {
            offset: 0,
            limit: pagination.limit
        }
        if (categoryName) {
            params.category_name = categoryName
        }
        if (parentCategory) {
            params.parent_category = parentCategory
        }
        const paginationData = await getSubCategories(setOurProjectCategories, params)
        if (paginationData) {
            setPagination(paginationData)
        }
    }

    const handleReset = async () => {
        setCategoryName("")
        setParentCategory("")
        setPagination(prev => ({
            ...prev,
            offset: 0
        }))
        const paginationData = await getSubCategories(setOurProjectCategories, {
            offset: 0,
            limit: pagination.limit
        })
        if (paginationData) {
            setPagination(paginationData)
        }
    }

    return (
        <>
            <div className="bg-gray-100 p-4 flex justify-between">
                <h2 className="text-2xl font-bold">Our Project Categories</h2>
                <button
                    className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
                    onClick={() => {
                        setCurrentOurProjectCategory(null);
                        setIsModalOpen(!isModalOpen)
                    }}
                >
                    Add Our Project Category
                </button>
            </div>

            <div className="mt-4">
                <div className="bg-white p-4 rounded-md shadow-md mb-6 flex gap-4 mt-4">
                    <input
                        type="text"
                        className="w-[40%] flex-grow px-4 py-2 border rounded-lg"
                        placeholder="Search by category name"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                    />
                    <select
                        className="w-[20%] px-4 py-2 border rounded-lg"
                        value={parentCategory}
                        onChange={(e) => setParentCategory(e.target.value)}
                    >
                        <option value="" className="opacity-25">
                            Select Parent Category
                        </option>
                        <option value="finishing">Finishing Projects</option>
                        <option value="grey_structure">Grey Structure Projects</option>
                    </select>
                    <button
                        className="w-full sm:w-[45%] md:w-60 bg-blue-500 text-white px-4 py-2 rounded-md"
                        onClick={handleSearch}
                    >
                        Search
                    </button>
                    <button
                        className="w-full sm:w-[45%] md:w-60 bg-primary-dark text-white px-4 py-2 rounded-md"
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                </div>
            </div>
            <div className="mt-4">
                <div className="bg-gray-100">
                    <div className="overflow-x-auto mt-6">
                        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                            <thead>
                                <tr className="bg-gradient-to-r from-primary-dark to-primary-light text-white">
                                    <th className="p-4 text-left">Sr. No</th>
                                    <th className="p-4 text-left">Category Name</th>
                                    <th className="p-4 text-left">Parent Category Name</th>
                                    <th className="p-4 text-left">Image</th>
                                    <th className="p-4 text-left">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ourProjectCategories.map((ourProjectCategory, index) => (
                                    <tr
                                        key={ourProjectCategory.id}
                                        className="border-t border-gray-200 hover:bg-gray-50"
                                    >
                                        <td className="p-4">
                                            <button
                                                onClick={() => handlePositionClick(ourProjectCategory)}
                                                className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
                                            >
                                                {ourProjectCategory.position}
                                            </button>
                                        </td>
                                        <td className="p-4">{ourProjectCategory.name}</td>
                                        <td className="p-4">{ourProjectCategory.parentCategory.name}</td>
                                        <td className="p-4"> <img src={ourProjectCategory.image_url} alt="image" className='w-10 h-10 rounded-full' /></td>
                                        <td className="px-4 py-2 border-b">
                                            <div className='flex gap-2'>
                                                <div className="flex gap-2">
                                                    <button
                                                        className="bg-primary-dark text-white py-2 px-4 rounded-lg shadow-md flex items-center"
                                                        onClick={() => handleEditOurProjectCategory(ourProjectCategory)}
                                                    >
                                                        <MdEdit />
                                                    </button>
                                                </div>
                                                <div className="flex gap-2">
                                                    <button
                                                        className="bg-primary-dark text-white py-2 px-4 rounded-lg shadow-md flex items-center"
                                                        onClick={() => handlePageView(ourProjectCategory.id)}
                                                    >
                                                        <IoEye />
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Pagination */}
            {pagination.totalPages > 1 && (
                <div className="mt-6">
                    <GlobalPagination
                        offset={pagination.offset}
                        limit={pagination.limit}
                        total={pagination.totalCount}
                        onPageChange={handlePageChange}
                        className="mx-4"
                    />
                </div>
            )}

            {isModalOpen && (
                <SubCategoryModal
                    currentOurProjectCategory={currentOurProjectCategory}
                    toggleModal={toggleModal}
                    onSuccess={refreshData}
                />
            )}

            {isPositionModalOpen && selectedCategoryForPosition && (
                <RecordPosition
                    isOpen={isPositionModalOpen}
                    onClose={closePositionModal}
                    currentPosition={selectedCategoryForPosition.position}
                    recordId={selectedCategoryForPosition.id}
                    onUpdatePosition={handleUpdatePosition}
                    moduleName="Category"
                />
            )}
        </>
    )
}
export default OurProjectCategories